import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PossibleTips } from '../types/StandalonePayment';

export interface PaymentTip {
  possibleTips: PossibleTips[];
  locale: string;
  currencyIsoCode: string;
  currencySymbol: string;
  amountSelected: number;
}

@Component({
  selector: 'app-store-payment-tip',
  templateUrl: './store-payment-tip.component.html',
  styleUrls: ['./store-payment-tip.component.scss']
})
export class StorePaymentTipComponent implements OnInit {
  @Input() customTipData: PaymentTip;
  @Input() selectedTipValue: number = 0;
  @Output() tipChange = new EventEmitter<PossibleTips>();
  tipAmountForm: FormGroup;
  selectedTipPosition: number = 1;
  private defaultPossibleTips: PossibleTips[] = [
    {
        "position": null,
        "tipPercentage": 0.00,
        "tipAmount": 0,
        "defaultTip": true,
        "custom": false
    },
    {
        "position": null,
        "tipPercentage": 0.00,
        "tipAmount": 0,
        "defaultTip": true,
        "custom": true
    },
  ];
  localTips: PaymentTip;

  constructor(
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.tipAmountForm = this.fb.group({
      specificAmount: ['', Validators.compose([Validators.min(0), Validators.max(999999), Validators.pattern('^[0-9].*$')])],
    });

    this.localTips = this.customTipData;

    this.defaultPossibleTips?.forEach((possibleTip: PossibleTips) => {
      this.localTips?.possibleTips.push(possibleTip);
    });

    this.calculateTips(this.customTipData.amountSelected, this.localTips);

    this.setSelectedTipByAmountValue(this.selectedTipValue);
  }

  calculateTips(amount: number, tips: PaymentTip) {
    let position = 1;
    tips?.possibleTips.forEach((possibleTip: PossibleTips) => {
      possibleTip.position = position;
      position++;
      possibleTip.tipAmount = this.roundTo(
        possibleTip.tipPercentage * amount
      );
    });
  }

  recalculateTips(amount: number) {
    this.localTips.amountSelected = amount;
    this.calculateTips(amount, this.localTips);
    this.onTipChange(this.localTips.possibleTips.find(tip => tip.position == this.selectedTipPosition));
  }

  onTipChange(tip: PossibleTips, clearCustomTip: boolean = false): void {
    if (clearCustomTip) {
      this.tipAmountForm.get('specificAmount').setValue(null);
    }
    this.setSelectedTipByPosition(tip.position);
    this.tipChange.emit(tip);
  }

  onCustomAmountChange() {
    if (this.tipAmountForm.get('specificAmount').value != this.getCustomTip().tipAmount) {
      this.getCustomTip().tipPercentage = this.tipAmountForm.get('specificAmount').value/this.localTips.amountSelected;
      this.getCustomTip().tipAmount = this.tipAmountForm.get('specificAmount').value;
      
      this.onTipChange({
        "position": this.getCustomTip().position,
        "tipPercentage": this.getCustomTip().tipPercentage,
        "tipAmount": this.getCustomTip().tipAmount,
      });
    }
  }

  getDefaultTips() {
    return this.localTips.possibleTips.filter(tip => tip.defaultTip);
  }

  getCustomTips() {
    return this.localTips.possibleTips.filter(tip => !tip.defaultTip);
  }

  getCustomTip() {
    return this.localTips.possibleTips.find(tip => tip.custom);
  }

  private setSelectedTipByPosition(position: number) {
    this.selectedTipPosition = position;
  }

  private setSelectedTipByAmountValue(selectedTipValue: number) {
    const findTip = this.localTips.possibleTips.find(tip => tip.tipAmount === selectedTipValue);
    if (findTip) {
      this.setSelectedTipByPosition(findTip.position);
    } else {
      if (selectedTipValue > 0) {
        this.tipAmountForm.get('specificAmount').setValue(selectedTipValue);
        this.setSelectedTipByPosition(this.localTips?.possibleTips[this.localTips?.possibleTips.length-1].position);
      }
    }
  }

  private roundTo(value: number): number {
    return Math.round(value * 100) / 100;
  }
}
